import React from 'react';
import TransitionGroup from 'react-transition-group/TransitionGroup'
import CSSTransition from 'react-transition-group/CSSTransition'
import RatesSearchActions from '../Actions/RatesSearchActions';

const FilterSummaryTransition = (props) => (
        <CSSTransition
            {...props}
            classNames="filter-summary"
            timeout={{ enter: 500, exit: 300 }}/>
)

class FilterSummary extends React.Component {

    getDefinitionItems(summary) {
        const truncateDefinitionItemsThreshold = 10;

        if(summary.get('all')) {
            return <FilterSummaryTransition>
                        <dd key={ "dd-all-selected:" + summary.get('label') }>All selected</dd>
                    </FilterSummaryTransition>;
        }

        if(summary.get('selectedValues').size == 0) {
            return <FilterSummaryTransition>
                                    <dd className="none-selected" key={ "dd-none-selected:" + summary.get('label') }>None selected</dd>
                    </FilterSummaryTransition>;
        }

        const selectedValues = summary.get('selectedValues');
        let definitionItems =
            selectedValues
                .slice(0, truncateDefinitionItemsThreshold)
                .map((value, index) => <dd key={ `dd-${index}` }>{ value }</dd>);

        if(selectedValues.size > truncateDefinitionItemsThreshold) {
            const truncatedListMessage = `...and ${selectedValues.size - truncateDefinitionItemsThreshold } others`
            definitionItems = definitionItems.push(<dd key="dd-and-others">{ truncatedListMessage }</dd>)
        }

        return definitionItems.map((item, index) =>
                    <FilterSummaryTransition key={index}>
                        {item}
                    </FilterSummaryTransition>)
    }

    onResetFilters = () => {
        RatesSearchActions.resetSearchCriteria();
    };

    getDefinitions = () => {
        const summariesToReport = this.props.summaries
            .filter(summary => !summary.get('all'));

        if (summariesToReport.size == 0) {
            return <li>All selected</li>
        }

        return summariesToReport.map((summary, index) =>
            (<li key={ `li-${index}` }>
                <dt>{ summary.get('label') }</dt>
                <div>
                    <TransitionGroup>
                        { this.getDefinitionItems(summary) }
                    </TransitionGroup>
                </div>
            </li>));
        }

    render() {
        return (
            <div id="FilterSummary">
                <div className="summary">
                    <dl>{ this.getDefinitions() }</dl>
                </div>
                <div className="right aligned container action">
                    <button type="button" className="button" onClick={ this.onResetFilters }>Reset filters</button>
                </div>
            </div>);
    }
}

export default FilterSummary;
